import api from "./api";

export const login = async (credentials) => {
  const response = await api.post("/auth/login", credentials);
  return response.data;
};

export const register = async (userData) => {
  const response = await api.post("/auth/register", userData);
  return response.data;
};

export const changePassword = async ({ currentPassword, newPassword }) => {
  const response = await api.put("/auth/change-password", {
    currentPassword,
    newPassword,
  });
  return response.data;
};

/**
 * Refresh the access token using refresh token
 * @param {string} refreshToken - The refresh token
 * @returns {Promise<{accessToken: string, refreshToken?: string}>}
 */
export const refreshAccessToken = async (refreshToken) => {
  const response = await api.post("/auth/refresh", { refreshToken }, {
    _skipAuthRefresh: true
  });
  return response.data;
};

/**
 * Logout - optionally notify backend to invalidate refresh token
 * @param {string} refreshToken - The refresh token to invalidate
 */
export const logoutApi = async (refreshToken) => {
  try {
    await api.post("/auth/logout", { refreshToken });
  } catch (error) {
    // Ignore errors on logout - we clear locally anyway
    console.warn('Logout API call failed:', error);
  }
};